export default __webpack_public_path__ + "static/media/IMG_1531.97651304.jpg";